import { Component, importProvidersFrom, Input, TemplateRef, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/services/app/app.service';
// import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { AdminService } from 'src/app/services/admin/admin.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { computeMsgId } from '@angular/compiler';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SpinnerComponent } from 'src/app/components/layout/spinner/spinner.component';
import { ErrorComponent } from 'src/app/components/layout/error/error.component';
import { timer } from 'rxjs';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'app-app-language',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    SpinnerComponent,
    ErrorComponent,
    TranslateModule
  ],
  templateUrl: './app-language.component.html',
  styleUrls: ['./app-language.component.css']
})

export class AppLanguageComponent implements OnInit {

  @Input() fromSetup = false;
  @Input() id = 0;

  private modalRef: NgbModalRef | null = null;

  load = false;
  error = false;
  data: any[] = [];
  selectedLanguages: any[] = [];
  saving = false;
  defaultLanguage!: string;

  loadBtn = false;
  faCheck = '';
  userId = 0;

  constructor(
    private activatedRoute: ActivatedRoute,
    public appService: AppService,
    private toastr: ToastrService,
    private router: Router,
    private translateService: TranslateService,
    private adminService: AdminService,
    private modalService: NgbModal,
  ) {

  }

ngOnInit() {
  if (!this.id) {
    const routeId = this.activatedRoute.snapshot.params['id'];
    if (routeId) {
      this.id = routeId;
    }
  }

  this.getLanguagesFromFile().then(() => {
    this.getActiveLanguages();
  });

  this.appService.showLanguages().subscribe(langs => {
    // console.log('[Component] Languages from service:', langs);
  });
}

  openLanguageModal(modalContent: TemplateRef<any>) {
    this.modalRef = this.modalService.open(modalContent, { 
      backdropClass: 'light-blue-backdrop',
      size: 'sm',
    });
  }

  close() {
    if (this.modalRef) {
      this.modalRef.close();
      this.modalRef = null;
    }
  }

  toggleAction(item: any, event: Event) {
    event.preventDefault(); // თავიდან ავიცილოთ სხვა მოქმედებები
    item.action = !item.action;
    // არჩეული ენების განახლება
    if (item.action && !this.selectedLanguages.some((lang) => lang.code === item.code)) {
      this.selectedLanguages.push(item);
    } else if (!item.action) {
      this.selectedLanguages = this.selectedLanguages.filter((lang) => lang.code !== item.code);
    }
  }


  

  // ენების ფაილიდან ჩასატვირთი ფუნქცია
getLanguagesFromFile(): Promise<void> {
  this.load = true;

  return new Promise((resolve, reject) => {
    this.appService.showLanguages().subscribe(
      (res: any) => {
        // console.log('ენების სია: ', res);
        this.data = res;
        this.load = false;
        resolve();
      },
      (error: any) => {
        // console.error('მოხდა შეცდომა ენების ჩატვირთვისას:', error);
        this.load = false;
        reject(error);
      }
    );
  });
}

  // Firebase-დან არჩეული ენების მიღება
  getActiveLanguages() {
  
    this.load = true;
    this.appService.getActiveLanguages(this.id.toString(), this.adminService.user.id.toString()).subscribe(
      (res: any) => {
        this.load = false;
        this.error = false;
  
        // Firebase-დან მიღებული ენების ლოგი
        // console.log("Active languages from Firebase:", res);
  
        // Firebase-დან წამოღებული მონაცემების დამუშავება
        if (res && res.languages && res.languages.length > 0) {
          this.data.forEach(lang => {
            const activeLang = res.languages.find((item: any) => item.code === lang.code);
            if (activeLang) {
              lang.action = activeLang.action; // Firebase მონაცემებით განახლება
              lang.default = activeLang.default; // Default ენის განახლება, თუ ეს ველი არსებობს Firebase-ში
            }
          });
  
          this.selectedLanguages = this.data.filter(lang => lang.action); // Active ენების შექმნა
          // console.log("Updated languages after merging with Firebase data:", this.selectedLanguages);
        
        } else {
          // console.warn('No active languages found in Firebase.');
        }
  
        this.setDefaultLanguage(); // Default ენის დაყენება
      },
      (error: any) => {
        // console.log('Error loading active languages:', error);
        this.error = true;
        this.load = false;

      }
    );
  }
  // Default ენის დაყენება
  setDefaultLanguage() {
    const defaultLanguage = this.data.find(item => item.default);

    if (defaultLanguage) {
      this.defaultLanguage = defaultLanguage.code;
    } else {
      const englishLanguage = this.data.find(item => item.code === 'en_US');
      if (englishLanguage) {
        this.defaultLanguage = englishLanguage.code;
        englishLanguage.default = true; // Default ენად არჩევა
      } else if (this.data.length > 0) {
        this.defaultLanguage = this.data[0].code;
        this.data[0].default = true;
      }
    }
    // console.log("Default language set to:", this.defaultLanguage); // Default ენის ლოგი
  }


  // პარამეტრების შენახვა
  save() {
    if (this.saving) return;
  
    this.saving = true;
  
    if (!this.defaultLanguage) {
      this.toastr.error(this.translateService.instant("ERROR_MESSAGE_DEFAULT_LANGUAGE"));
      this.saving = false;
      return;
    }
  
    const user_id = this.adminService.user.id;
    
    // Default ენის დაყენება
    this.data.forEach(item => {
      item.default = (item.code === this.defaultLanguage);
    });
  
    const activeLanguages = this.data.filter(item => item.action);
  
    // 'id' დაამატე 'updatedData'-ში
    const updatedData = {
      'appId': this.id, // დამატებული 'id' ველი
      'languages': activeLanguages,
      'userId': user_id
    };
    
    this.loadBtn = true;
  
    // console.log("Updated data to save:", updatedData); // შენახვის მონაცემების ლოგი
  
    this.appService.saveLanguages(updatedData).subscribe(
      (res: any) => {
        this.loadBtn = false;
        if (!this.fromSetup) {
          this.toastr.success(this.translateService.instant("SUCCESS_MESSAGE"));
        }
        if (this.fromSetup) {
          // console.log('Redirect Active');
          this.router.navigate(['/app/setup/', this.id, 'info'])
        }
        this.saving = false;
        this.close()
        
      },
      (error: any) => {
        this.loadBtn = false;
        this.toastr.error(this.translateService.instant("ERROR_MESSAGE"));
        this.saving = false;
      }
    );
  }
}